import emailjs from '@emailjs/browser';
import {
	faDiscord,
	faGithub,
	faLinkedin,
} from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRef, useState } from 'react';

function Contact() {
	const form = useRef();
	const [status, setStatus] = useState(''); // '', 'sending', 'success', 'error'
	const [message, setMessage] = useState('');

	const sendEmail = (e) => {
		e.preventDefault();
		setStatus('sending');
		setMessage('');

		emailjs
			.sendForm(
				'service_y5lybfj',
				'template_gyx8d49',
				form.current,
				'7HE3PA3BiZFeVq9rM'
			)
			.then(
				(result) => {
					console.log(result.text);
					setStatus('success');
					setMessage('Message sent successfully! ✓');
					form.current.reset();
					setTimeout(() => {
						setStatus('');
						setMessage('');
					}, 5000);
				},
				(error) => {
					console.log(error.text);
					setStatus('error');
					setMessage(
						'Failed to send message. Please try again or contact me directly.'
					);
					setTimeout(() => {
						setStatus('');
						setMessage('');
					}, 5000);
				}
			);
	};
	return (
		<div id="content-tabs" className="contact">
			<h1>
				&#x2039;
				<span className="title">Contact</span> &#47;&#x203A;
			</h1>
			<div className="contact-wrapper">
				<form ref={form} onSubmit={sendEmail}>
					<label>Name</label>
					<input type="text" name="user_name" placeholder="name_" required />
					<label>Email</label>
					<input
						type="email"
						name="user_email"
						placeholder="e-mail_"
						required
					/>
					<label>Message</label>
					<textarea name="message" placeholder="message_" required />
					<input
						type="submit"
						value={status === 'sending' ? 'Sending...' : 'Send'}
						className="sendBtn"
						disabled={status === 'sending'}
					/>
					{message && <p className={`form-message ${status}`}>{message}</p>}
				</form>
				<div className="social">
					<a href="mailto:massimianisilvia@gmail.com" target="blank_">
						<FontAwesomeIcon
							icon={faEnvelope}
							size="2x"
							className="icon-contact"
						/>
					</a>
					<a href="https://github.com/massi-17" target="blank_">
						<FontAwesomeIcon
							icon={faGithub}
							size="2x"
							className="icon-contact"
						/>
					</a>
					<a
						href="https://www.linkedin.com/in/silviamassimiani/"
						target="blank_"
					>
						<FontAwesomeIcon
							icon={faLinkedin}
							size="2x"
							className="icon-contact"
						/>
					</a>
					<a href="https://Massi17#5689" target="blank_">
						<FontAwesomeIcon
							icon={faDiscord}
							size="2x"
							className="icon-contact"
						/>
					</a>
				</div>
			</div>
		</div>
	);
}
export default Contact;
